import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { accidentConfig } from './configByInsuranceType/accident';
import { belongingsConfig } from './configByInsuranceType/belongings';
import { billProtectionConfig } from './configByInsuranceType/bill-protection';
import { healthConfig } from './configByInsuranceType/health';
import { liabilityBusinessConfig } from './configByInsuranceType/liabilityBusiness';
import { lifeConfig } from './configByInsuranceType/life';
import { paymentProtectionConfig } from './configByInsuranceType/payment-protection';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: false,
    showCurrentCapitalValue: true,
    claims: claimsConfig.RO,
    dashboard: dashboardConfig.RO,
    funds: fundsConfig.RO,
    modifications: modificationsConfig.RO,
    servicing: servicingConfig.RO,
    accident: accidentConfig.RO,
    belongings: belongingsConfig.RO,
    billProtection: billProtectionConfig.RO,
    health: healthConfig.RO,
    liabilityBusiness: liabilityBusinessConfig.RO,
    life: lifeConfig.RO,
    paymentProtection: paymentProtectionConfig.RO,
    product: productConfig.RO,
    property: propertyConfig.RO,
    travel: travelConfig.RO,
};
